import { render, staticRenderFns } from "./SubVideoPane.vue?vue&type=template&id=3a43b5b1&scoped=true"
import script from "./SubVideoPane.vue?vue&type=script&lang=ts"
export * from "./SubVideoPane.vue?vue&type=script&lang=ts"
import style0 from "./SubVideoPane.vue?vue&type=style&index=0&id=3a43b5b1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a43b5b1",
  null
  
)

export default component.exports